import { push } from "connected-react-router";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import {
  APPLICATION_MODE_NEW,
  // LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
  DOCUMENT_CONTENT_TYPE_PDF,
  individualFileSizeAllowedInMB,
  ROUTE_PATH,
  REQUEST_STATUS,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE
} from "../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  NavigationLinkButton,
} from "../../components/RegularComponents";
// import CheckboxForm from "../../components/CheckBoxForm";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { addCurrentAgentBrokerCourseCertificate, setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import {
  acceptedFileFormats,
  convertFileDataForUrl,
  extractBase64, 
  fileNameWithLengthLimit, 
  fileTypeEnum, 
  validateFileName
} from "../../app/documentUploadUtils";
import { fetchDocumentData } from "../../redux/slice/supportingDocumentsSlice";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../components/DocumentViewer/DocumentFileComponent";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";
import CheckBoxForm from "../../components/CheckBoxForm";
import { fullName } from "../../app/utils";

const MORTGAGE_APPLICATION_PROPERTY = "confirmRequiredCourseCompletion";

export const PrincipalBrokerUploadCertificateMortgageEducation = (props) => {

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  // const isAssociateBroker = licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const dispatch = useDispatch();
  
  const applicationMode = APPLICATION_MODE_NEW;
  const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [confirmCheck, setConfirmCheck] = useState(false);

  const [
    certificateMortgageEducationFile,
    setCertificateMortgageEducationFile,
  ] = useState({});

  const fileSizeReplacement = (string, fileSize) => { 
    const replaceRegExp = /<file_size>/g 
    const errorString = string.replace(replaceRegExp,(fileSize + "MB"))
    return errorString
  }

  const handleFileInput = (e) => {
    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      
      // individual file size can not be more than 15 MB
      if(file.size > (individualFileSizeAllowedInMB * (2 ** 20))) { 
        alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,individualFileSizeAllowedInMB))
        return
      } else if(!validateFileName(file.name)) {
        alert("File name is not valid. Please select another file.")
        return
      }

      let reader = new FileReader();
      reader.onload = (readerData) => {
        setCertificateMortgageEducationFile({
          filename: fileNameWithLengthLimit(file.name),
          documentContentType: fileTypeEnum(file.type),
          data: extractBase64(readerData.target.result),
          changeType: "SAVE",
          documentType: DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE,
          fileSize : file.size
        });
      };
      reader.readAsDataURL(file);

      // reset validation errors
      setShowValidationError(false);
    }
  };

  const handleSaveNext = () => {
    setApplicationSaveError(false);
    setShowValidationError(false);

    // if(!certificateMortgageEducationFile 
    //   || Object.keys(certificateMortgageEducationFile).length === 0) { 
    //   setShowValidationError(true)
    //   return
    // }

    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: true,
      })
    );

    dispatch(addCurrentAgentBrokerCourseCertificate(certificateMortgageEducationFile))

    // On to the next item
    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        let nextPath = ROUTE_PATH.MRA_BROKER_CONTACT_INFORMATION

        if(!isPrincipalBroker) {
          nextPath = ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION;
        }

        dispatch(
          push(`${ROUTE_PATH.MRA_APP}${nextPath}`)
        );
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const fileComponent =  useCallback(() => {
    const file = certificateMortgageEducationFile

    return (
      <>
          <div className="supportingDocumentsFileContentWrapper">
              <span className="fileName">
                  {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                      <DocumentViewerFileNameLink
                          id={"education-certificate-file-" + file.filename}
                          key={"education-certificate-file-" + file.filename}
                          file={file}
                          onClick={() => { 
                              if(file.data) { 
                                  let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                  setDocumentViewerDocument(fileDataUrl)
                                  setOpenDocumentViewer(true)
                              } else { 
                                  // download data and then view it.
                                  if(file.guid) { 
                                      dispatch(fetchDocumentData(file.guid))
                                          .then(downloadFile => {
                                              if(downloadFile) { 
                                                  let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                  setDocumentViewerDocument(fileDataUrl)
                                                  setOpenDocumentViewer(true)
                                              }
                                          })
                                          .catch((error) => {
                                              console.error(error)
                                          })
                                  }
                              }
                          }}
                      /> : 
                      <DownloadFileNameLink
                          id={"education-certificate-file-" + file.filename}
                          componentKey={"education-certificate-file-" + file.filename}
                          file={file} 
                      />
                  }
              </span>
              
              <NavigationLinkButton
                  id={"education-certificate-file-remove-link"}
                  text={"- Remove this file"}
                  onClick={() => {
                    setCertificateMortgageEducationFile({})
                  }}
              />
          </div>
      </>
  )
  }, [certificateMortgageEducationFile, dispatch])

  useEffect(() => {
    const brokerDocuments = agentApplication?.documents ?? []
    const educationCertificates = brokerDocuments.filter(document => document.documentType === DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE && document.changeType !== "DELETE")

    if(educationCertificates?.length > 0)
      setCertificateMortgageEducationFile(educationCertificates[0])

    if (agentApplication?.businessLicenceData?.confirmRequiredCourseCompletion) {
      setConfirmCheck(agentApplication?.businessLicenceData?.confirmRequiredCourseCompletion)
    }

  },[agentApplication, setCertificateMortgageEducationFile, setConfirmCheck])

  const applicantName = fullName(agentApplication?.businessLicenceData?.personData) ?? 'the applicant';
  const headerText = `${isPrincipalBroker ? 'You must' : 'The applicant must'} complete the Nova Scotia Mortgage Broker course before the date ${isPrincipalBroker ? 'your' : 'their'} new licence expires.`;
  const confirmationText = `Yes, I confirm that ${isPrincipalBroker ? 'I' : applicantName} will complete the Nova Scotia Mortgage Broker course before the date the new licence expires.`
  
  return (
    <>
      <div className={"container"}>
        <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              style={{ paddingBottom: "30px" }}
              id="upload-mortgage-education-header"
              header={headerText}
            />
          </div>
        </div>

        <div className="row">
        <div className="col-xs-12 col-lg-9">
            <CheckBoxForm
              id="confirm-pb-education"
              checked={confirmCheck}
              value={confirmCheck}
              labelText={confirmationText}
              onCheckBoxChange={(val) => {
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph 
              id="upload-eduction-certification-info-text" 
              text={[
                "If it has already been completed, upload the certificate of completion below."
              ]}
            />
          </div>
        </div>

        <div className="row bottomMarginMedium">
          <div className="col-xs-12 col-lg-8">
            {(certificateMortgageEducationFile 
              && Object.keys(certificateMortgageEducationFile).length > 0) &&
            fileComponent()}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <fieldset className="ns-fieldset" id="certificate-education-form">
              <div className={"ns-fieldset"} style={{ paddingBottom: "20px" }}>
                <label
                  className="ns-label"
                  id="upload-certificate-education-file-label"
                  htmlFor="upload-certificate-education-file-input"
                >
                  Upload a file
                </label>
                <div className="ns-file-input">
                  <input
                    disabled={(certificateMortgageEducationFile 
                      && Object.keys(certificateMortgageEducationFile).length > 0)}
                    className="ns-input"
                    style={{width: "15em", display: "inline"}}
                    type="file"
                    value=""
                    accept={acceptedFileFormats(DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE).join(',')}
                    id="upload-certificate-education-file-input"
                    name="upload-certificate-education-file-input"
                    multiple={false}
                    onInput={handleFileInput}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              style={{ paddingBottom: "20px" }}
              id="upload-mortgage-education-text"
              text={[
                "The maximum file size allowed is 15 MB per file and 50 MB total. Supported document types are Microsoft Word, Microsoft Office Excel, or Adobe PDF.  All digital files must be in an uncompressed format, i.e no zip or ARC files.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + ((applicationSaveError || showValidationError) ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Save and next"}
              onClick={handleSaveNext}
              showSpinner={!applicationSaveError && 
                (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
            />
            {(applicationSaveError || showValidationError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.UPLOAD_CERTIFICATE_ERROR}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>

        <DocumentViewer 
            fileData={documentViewerDocument}
            isOpen={openDocumentViewer}
            fileName={certificateMortgageEducationFile?.filename}
            handleClose={() => setOpenDocumentViewer(false)}
        />

      </div>
    </>
  );
};
